import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const services = [
  {
    title: "Terrassement complet",
    description: "Préparation et transformation complète de votre terrain pour un résultat solide et durable.",
    image: "https://images.unsplash.com/photo-1657383543368-7d929944be6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiYWNreWFyZCUyMHBvb2wlMjBuaWdodCUyMGNpbmVtYXRpYyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3MzYyOTQ5MHww&ixlib=rb-4.1.0&q=85",
    num: "01"
  },
  {
    title: "Plantation arbres matures",
    description: "Sélection et plantation d'arbres matures pour un impact visuel immédiat et une valeur ajoutée à votre propriété.",
    image: "https://images.unsplash.com/photo-1763222208594-58426d30d3c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzdG9uZSUyMGdhcmRlbiUyMHBhdGglMjBsdXh1cnklMjBsYW5kc2NhcGluZ3xlbnwwfHx8fDE3NzM2Mjk0OTF8MA&ixlib=rb-4.1.0&q=85",
    num: "02"
  },
  {
    title: "Pavé uni",
    description: "Installation de pavé uni avec des motifs et finitions qui définissent l'élégance extérieure.",
    image: "https://images.unsplash.com/photo-1693834485948-e90a1e2c88ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBvdXRkb29yJTIwZmlyZSUyMHBpdCUyMGxvdW5nZSUyMGV2ZW5pbmd8ZW58MHx8fHwxNzczNjI5NDkyfDA&ixlib=rb-4.1.0&q=85",
    num: "03"
  },
  {
    title: "Excavation",
    description: "Travaux d'excavation professionnels avec équipements spécialisés pour tous types de projets.",
    image: "https://images.unsplash.com/photo-1712697236445-fad56534129e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxsYW5kc2NhcGUlMjBhcmNoaXRlY3QlMjBkcmF3aW5nJTIwcGxhbnMlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc3MzYyOTQ5Mnww&ixlib=rb-4.1.0&q=85",
    num: "04"
  },
  {
    title: "Muret de roches",
    description: "Construction de murets en pierres naturelles pour structurer et embellir vos espaces extérieurs.",
    image: "https://images.unsplash.com/photo-1626075246403-544a14566c3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiYWNreWFyZCUyMHBvb2wlMjBuaWdodCUyMGNpbmVtYXRpYyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3MzYyOTQ5MHww&ixlib=rb-4.1.0&q=85",
    num: "05"
  },
  {
    title: "Nivèlement de terre à gazon",
    description: "Nivèlement précis avec top soil de qualité pour une pelouse uniforme et luxuriante.",
    image: "https://images.unsplash.com/photo-1702421093671-cc31dee8b7aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBzdG9uZSUyMGdhcmRlbiUyMHBhdGglMjBsdXh1cnklMjBsYW5kc2NhcGluZ3xlbnwwfHx8fDE3NzM2Mjk0OTF8MA&ixlib=rb-4.1.0&q=85",
    num: "06"
  }
];

export const ServicesSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="services" className="py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A]" data-testid="services-section" ref={ref}>
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="mb-16"
        >
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#E8891C] mb-4">Nos expertises</p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#F5F5F0] tracking-tight" data-testid="services-title">
            Services <span className="italic">d'exception</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1px] bg-[#2A2A2A]/30">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: index * 0.1, ease: "easeOut" }}
              className="group relative bg-[#0A0A0A] overflow-hidden"
              data-testid={`service-card-${index}`}
            >
              {/* Image background */}
              <div className="absolute inset-0 opacity-20 group-hover:opacity-40 transition-opacity duration-700">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
              </div>

              <div className="relative z-10 p-8 md:p-10 min-h-[280px] flex flex-col justify-between">
                <div>
                  <span className="font-sans text-xs text-[#E8891C]/60 tracking-[0.2em] mb-6 block">{service.num}</span>
                  <h3 className="font-serif text-xl md:text-2xl text-[#F5F5F0] mb-4 group-hover:text-[#E8891C] transition-colors duration-500" data-testid={`service-title-${index}`}>
                    {service.title}
                  </h3>
                </div>
                <p className="font-sans text-sm text-[#A1A1AA] leading-relaxed">
                  {service.description}
                </p>
              </div>

              {/* Bottom gold line on hover */}
              <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#E8891C] scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
